import React from 'react';
import styled from 'styled-components';

import { PrimaryButton } from './Button';
import QuantitySelector from "../components/QuantitySelector";
import { Header5, Body } from './typography';
import InlineNewsletter from './InlineNewsletter';

const Layout = styled.div`

  > div:first-child {
    display: flex;
    justify-content: space-between;

    ${Header5}:first-child {
      color: #7F222E;
    }
  }

    > ${Body} {
      margin: 16px 0;
      color: #2F3335;
    }
`;

const ButtonsContainer = styled.div`
  display: flex;

  margin-bottom: 20px;

  & > button {
    margin-right: 20px;
  }

  & > div {
    flex: 0 0 auto;
    height: 64px;
  }
`

export default function OutOfStock({ product, onAddToCart, onQuantityChange }) {
  return (
    <Layout>
      <div>
        <div>
          <Header5>Out of Stock</Header5>
          <Body>(But buy now, receive 10% off)</Body>
        </div>
        <Header5>$27.00</Header5>
      </div>
      <Body>*With code <strong>SPFLIST</strong>, and we'll ship your order as soon as it's back in stock (ETA 10/7).</Body>
      <ButtonsContainer>
        <PrimaryButton onClick={onAddToCart}>
          Add to Cart
            </PrimaryButton>

        <QuantitySelector onChange={onQuantityChange} />
      </ButtonsContainer>
      <Header5>
        Or we can notify you when it's back in stock:
        </Header5>
      <InlineNewsletter />
    </Layout>
  )
}